export default __webpack_public_path__ + "static/media/25-460x460.7ef11d56.jpeg";